import React from "react";
import { createRoot } from "react-dom/client";
import { SessionManager } from "./lib/session-manager";
import { IntlProvider } from "react-intl";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import LogRocket from "logrocket";
import setupLogRocketReact from "logrocket-react";
import { store } from "./Helper";
import { App } from "./App";
import { operationService } from "./Service/OperationService";

const env = import.meta.env.VITE_ENV || "prod";

if (env === "prod") {
  LogRocket.init("sks4it/workload");
  setupLogRocketReact(LogRocket);
}

SessionManager.setTokenKey(`app-${operationService.getSlug()}`);
SessionManager.setTokenKeyExpired(`expired-${operationService.getSlug()}`);
SessionManager.setAppSlug(operationService.getSlug());

const root = createRoot(document.getElementById("root"));
root.render(
  <IntlProvider locale="fr">
    <BrowserRouter>
      <Provider store={store}>
        <App />
      </Provider>
    </BrowserRouter>
  </IntlProvider>
);
